import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: 'Flex Home' },
  { path: 'enelx', component: HomeComponent },
  { path: 'endesa', component: HomeComponent },
  { path: 'dte', component: HomeComponent },
  { path: 'consumersenergy', component: HomeComponent },
  { path: 'agora', component: HomeComponent }
];
